/**
 * aes-survey 所操作的 indexedDB 数据库名称
 */
var AES_SURVEY_DATABASE = 'aes-survey';

/**
 * aes-survey 数据库版本号
 */
var AES_SURVEY_VERSION = 1;

/**
 * aes-survey 所操作的数据库的 objectStore 名称
 */
var AES_OBJECT_STORE_NAME = 'aes-survey-idb';

/**
 * promise 对象，用于异步获取 indexedDB 数据库
 */
var databasePromise = new Promise(function (resolve, reject) {
  try {
    var aesDBRequest = window.indexedDB.open(AES_SURVEY_DATABASE, AES_SURVEY_VERSION);
    aesDBRequest.onerror = function () {
      return reject(aesDBRequest.error);
    };
    aesDBRequest.onsuccess = function () {
      return resolve(aesDBRequest.result);
    };
    aesDBRequest.onupgradeneeded = function () {
      return aesDBRequest.result.createObjectStore(AES_OBJECT_STORE_NAME);
    };
  } catch (error) {
    throw new Error('该浏览器不支持indexedDB');
  }
});

/**
 * 操作 indexedDB 的核心方法
 *
 * 如果本地浏览器不支持 indexedDB，降级为使用 localStorage 存储
 *
 * @param {'readwrite' | 'readonly'} type 访问数据库时的数据库事务类型
 * @param {'get' | 'delete' | 'put'} method 调用的方法名
 * @param {string} key 需要操作的 key 值
 * @param {any} value 需要操作的 key 对应的 value
 * @returns
 */
export var handleLocalStoreData = function handleLocalStoreData(type, method, key) {
  var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  try {
    return new Promise(function (resolve, reject) {
      databasePromise.then(function (db) {
        try {
          var transaction = db.transaction(AES_OBJECT_STORE_NAME, type);
          var store = transaction.objectStore(AES_OBJECT_STORE_NAME);
          var req = handleStoreByMethod(store, method, key, value);
          transaction.oncomplete = function () {
            return resolve(req);
          };
          transaction.onabort = transaction.onerror = function () {
            return reject(transaction.error);
          };
        } catch (error) {
          reject(error);
        }
      });
    });
  } catch (error) {
    // 若不支持indexDB，转为 localStorage
    return new Promise(function (resolve, reject) {
      try {
        switch (method) {
          case 'get':
            var res = localStorage.getItem(key);
            resolve({
              result: res
            });
          case 'delete':
            localStorage.removeItem(key);
            resolve({
              result: 'success'
            });
          case 'put':
            localStorage.setItem(key, value);
            resolve({
              result: 'success'
            });
        }
      } catch (error) {
        var defaultErrorMessage = '该浏览器不支持localStorage';
        console.log(defaultErrorMessage);
        reject(defaultErrorMessage);
      }
    });
  }
};

/**
 * 根据 key 获取 indexDB 中的值
 * @param {string} key
 * @returns 处理结果的 promise
 */
export var get = function get(key) {
  return new Promise(function (resolve, reject) {
    try {
      handleLocalStoreData('readonly', 'get', key).then(function (res) {
        var result = res.result;
        resolve(result);
      });
    } catch (e) {
      reject();
    }
  });
};

/**
 * 更新 indexedDB 中的键值对
 * @param {string} key
 * @param {any} value
 * @returns 处理结果的 promise
 */
export var set = function set(key, value) {
  return value == null ? handleLocalStoreData('readwrite', 'delete', key) : handleLocalStoreData('readwrite', 'put', key, value);
};

/**
 * 删除 indexedDB 中的键值对
 * @param {string} key
 * @returns 处理结果的 promise
 */
export var del = function del(key) {
  return new Promise(function (resolve, reject) {
    try {
      handleLocalStoreData('readwrite', 'delete', key).then(function (res) {
        var result = res.result;
        resolve(result);
      });
    } catch (e) {
      reject();
    }
  });
};

/**
 * 处理 indexedDB ObjectStore 对象的方法，根据 store 对象和方法名，调用相应的 API
 * @param {IDBObjectStore} objectStore indexedDB ObjectStore 对象
 * @param {string} method 调用方法
 * @param {string} key
 * @param {string} value
 * @returns 处理的返回结果
 */
var handleStoreByMethod = function handleStoreByMethod(objectStore, method, key, value) {
  var req;
  if (method === 'put') {
    req = objectStore.put(value, key);
  } else if (method === 'delete') {
    req = objectStore.delete(key);
  } else if (method === 'get') {
    req = objectStore.get(key);
  }
  return req;
};